import { render, staticRenderFns } from "./TheEvidenceMove.vue?vue&type=template&id=99b2078c&scoped=true&"
import script from "./TheEvidenceMove.vue?vue&type=script&lang=js&"
export * from "./TheEvidenceMove.vue?vue&type=script&lang=js&"
import style0 from "./TheEvidenceMove.vue?vue&type=style&index=0&id=99b2078c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b2078c",
  null
  
)

export default component.exports